"use strict";

import Vue from 'vue';
import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
 axios.defaults.baseURL =  '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let config = {
    baseURL :  process.env.NODE_ENV=='development' ? 'api' : '',
    //process.env.NODE_ENV=='development' ? 'api' :
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
   validateStatus: () => {
    return true; // I'm always returning true, you may want to do it depending on the status received
  },
};
//axios.defaults.withCredentials = true

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
      // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return error;
    //return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;